<div class="preview-details">
    <!-- <h3 class="text-base--primary">Preview Details</h3>
    <p class="text-description">Please review the account details below before proceeding to confirmation.</p> -->

    <div
        class="preview-details__container"
        [class.preview-details__container--dealer]="selectedUserType()?.id === 'dealer'">
        <!-- Sidebar -->
        <aside
            class="preview-details__sidebar"
            [class.preview-details__sidebar--dealer]="selectedUserType()?.id === 'dealer'">
            <div class="preview-details__avatar-wrapper">
                <app-avatar-uploader
                    variant="sidebar"
                    [isEditable]="false"
                    [imageUrl]="
                        profilePicturePreview() ||
                        $any(draftData())?.profilePicture ||
                        '/default_profile.png'
                    " />
            </div>

            <h2 class="preview-details__sidebar-title">Check your account information</h2>
            <p class="preview-details__sidebar-description">
                Please review the {{ selectedUserType()?.label }} account details below before
                proceeding to confirmation.
            </p>

            <div class="preview-details__sidebar-divider"></div>
        </aside>

        <!-- Main Content -->
        <main class="preview-details__main">
            <div class="preview-details__card">
                <div class="preview-details__header">
                    <div class="preview-details__header-left">
                        <svg class="preview-details__header-icon">
                            <use href="assets/icons/icons-sprite.svg#account-details" />
                        </svg>
                        <h1 class="preview-details__title">Account Details</h1>
                    </div>
                    <button class="preview-details__edit-btn" (click)="onGoToInputInformation()">
                        <span>Edit</span>
                        <svg class="preview-details__edit-icon">
                            <use href="assets/icons/icons-sprite.svg#pencil-edit" />
                        </svg>
                    </button>
                </div>

                <div class="preview-details__form">
                    @for (row of previewFieldRows(); track $index) {
                        <div
                            class="preview-details__form-row"
                            [class.preview-details__form-row--full]="row.fullWidth">
                            <div
                                [class.preview-details__field-grid]="row.fields.length > 1"
                                [class.preview-details__field-grid--single]="
                                    row.fields.length === 1
                                ">
                                @for (field of row.fields; track field.fieldName) {
                                    <div class="preview-details__field">
                                        <label class="preview-details__label">{{
                                            field.label
                                        }}</label>
                                        <div class="preview-details__value">
                                            @if (field.fieldName === 'password') {
                                                <div class="preview-details__value-content">
                                                    <span class="preview-details__value-text">
                                                        {{
                                                            getDisplayFieldValue(
                                                                field.fieldName,
                                                                'input-information'
                                                            )
                                                        }}
                                                    </span>
                                                    <button
                                                        type="button"
                                                        class="preview-details__view-password-btn"
                                                        (click)="onTogglePasswordVisibility()">
                                                        {{ isPasswordVisible() ? 'Hide' : 'View' }}
                                                    </button>
                                                </div>
                                            } @else {
                                                {{
                                                    getDisplayFieldValue(
                                                        field.fieldName,
                                                        'input-information'
                                                    )
                                                }}
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

                <div class="preview-details__extra">
                    @for (field of FORM_FIELDS?.extra; track field) {
                        @if (
                            field.fieldName === 'selectedDealers' && selectedDealers().length > 0
                        ) {
                            <label class="preview-details__label">{{ field.label }}</label>
                            <div class="preview-details__tags">
                                @for (dealer of selectedDealers(); track dealer) {
                                    <div class="preview-details__tag">
                                        <span>
                                            {{ dealer.label }}
                                        </span>
                                        <svg
                                            tabindex="0"
                                            role="button"
                                            (click)="onRemoveSelectedDealer(dealer.value)"
                                            class="preview-details__tag-close">
                                            <use href="assets/icons/icons-sprite.svg#close" />
                                        </svg>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>

                <!-- Submit Section -->
                <div class="preview-details__submit-section">
                    <div class="preview-details__submit-header">
                        <div class="preview-details__submit-icon-wrapper">
                            <svg class="preview-details__submit-icon">
                                <use href="assets/icons/icons-sprite.svg#check" />
                            </svg>
                        </div>
                        <div class="preview-details__submit-content">
                            <h3 class="preview-details__submit-title">Ready to Submit?</h3>
                            <p class="preview-details__submit-description">
                                {{ submitNotes.heading }}
                            </p>
                            <ul class="preview-details__submit-list">
                                @for (note of submitNotes.notes; track note) {
                                    <li class="preview-details__submit-list-item">
                                        {{ note }}
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>

                    <div class="preview-details__confirmation">
                        <div
                            class="preview-details__confirmation-popover"
                            role="alert"
                            aria-live="polite">
                            <div class="preview-details__confirmation-alert">
                                <svg class="preview-details__alert-icon">
                                    <use href="assets/icons/icons-sprite.svg#info-circle" />
                                </svg>
                                <span>This is a required field. Please check to confirm.</span>
                            </div>
                        </div>
                        <div class="preview-details__confirmation-checkbox">
                            <ntv-checkbox
                                [(checked)]="isConfirmationChecked"
                                label="I confirm that all the information provided is accurate and complete"
                                size="md"
                                color="accent" />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</div>
